import React from 'react';
import styled, { ThemeProps } from 'styled-components';
import { Column, Row } from '../../components/Grid';
import { Anker } from '../../components/Link';
import { SvgIcon } from '../../components/SvgIcon';
import {
  selectIsPathContentLoaded,
  selectMenu
} from '../../provider/Typo3Provider/selectors';
import {
  withTypo3,
  WithTypo3Props
} from '../../provider/Typo3Provider/withTypo3';
import { Theme } from '../../theme';
import { media } from '../../theme/base/mixins';
import { StyledDivComponent } from '../../types';

const FooterBrands: StyledDivComponent = styled.div`
  &:before {
    height: 1px;
    background: ${(props: ThemeProps<Theme>) => props.theme.colors.white};
    width: 100%;
    content: '';
    position: absolute;
    left: 0;
  }

  ${media.large`
    &:before {
      display: none;
    }
  `};
`;

const BrandsContainer = ({ typo3 }: WithTypo3Props) => {
  const isPathContentLoaded = selectIsPathContentLoaded(typo3);
  if (!isPathContentLoaded) {
    return null;
  }
  const footerLogos = selectMenu(typo3, 'footerlogos');
  if (footerLogos.length !== 3) {
    return null;
  }
  const [mercedesEntry, setraEntry, omniplusEntry] = footerLogos;
  return (
    <FooterBrands>
      <Row noGap>
        <Column small={6} large={4}>
          {mercedesEntry && (
            <Anker href={mercedesEntry.link} target="_blank">
              <SvgIcon icon="footer_mercedes" />
            </Anker>
          )}
        </Column>
        <Column small={6} large={4}>
          {setraEntry && (
            <Anker href={setraEntry.link} target="_blank">
              <SvgIcon icon="footer_setra" />
            </Anker>
          )}
        </Column>
        <Column small={6} large={4}>
          {omniplusEntry && (
            <Anker href={omniplusEntry.link} target="_blank">
              <SvgIcon icon="footer_omniplus" />
            </Anker>
          )}
        </Column>
      </Row>
    </FooterBrands>
  );
};
export default withTypo3<{}>(BrandsContainer);
